<daui-pull-to-refresh
  [isCompleted]="isPullToRefreshCompleted"
  (inProgress)="onInProgress($event)"
  [disabled]="!hasPullToRefresh"
>
  <div
    class="wrapper"
    [ngClass]="{
      indicator: hasIndicator,
      top: currentScrollPosition === scrollPosition.Top,
      bottom: currentScrollPosition === scrollPosition.Bottom,
      none: currentScrollPosition === scrollPosition.None
    }"
    (dauiResize)="onResize()"
  >
    <div
      #scroll
      class="scroll"
      (scroll)="onElementScroll($event)"
      [ngClass]="{
        'overflow-auto': overflow === scrollOverflow.Auto,
        'overflow-x': overflow === scrollOverflow.X,
        'overflow-y': overflow === scrollOverflow.Y,
        mouseDown: isDown
      }"
    >
      <ng-content></ng-content>
    </div>
  </div>
</daui-pull-to-refresh>
